import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import DashboardCommonHeader from "../../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { TotalExpendituresTitle } from "../../../../../Constants/Constants";
import { H2, H6 } from "../../../../../AbstractElements";
import SvgIcon from "../../../../CommonComponents/SvgIcon/SvgIcon";
import ReactApexChart from "react-apexcharts";
import { ExpensesChart } from "../../../../../Data/General/Dashboard/Default";

const TotalExpenditure = () => {
  return (
    <Col xl="3" md="6" className="expenses-card">
      <Card className="earning-card">
        <DashboardCommonHeader title={TotalExpendituresTitle} dropdownClass="dropdown-toggle" />
        <CardBody className="pb-0">
          <Row>
            <Col xxl="7" xl="12" lg="8" md="7" sm="8" className="box-col-12">
              <div className="expenses-chart" id="Expenses-chart">
                <ReactApexChart type="bar" options={ExpensesChart} series={ExpensesChart.series} height={170} />
              </div>
            </Col>
            <Col xl="5" lg="4" md="5" sm="4" className="earning-content">
              <div className="total-header p-2 pt-0">
                <H2 className="mb-2">{`$ 16,842`}</H2>
                <div className="d-flex">
                  <span className="bg-light-success">
                    <SvgIcon iconId="up-arrow" />
                  </span>
                  <H6 className="font-success">{`+ 40.09%`}</H6>
                </div>
                <span>{`Than last week`}</span>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TotalExpenditure;
